import { Component, OnInit, } from '@angular/core';
import { CopyService } from '../../shared/services/copies/copy.service';
import { FormBuilder, ControlContainer, FormGroup, Validators } from '@angular/forms';
import { LinkupService } from '../../shared/services/link-up/linkup.service';
import { getValueProperty, setValueProperty } from '../../shared/helpers/functions.helpers';
import { ApplicationService } from '../../shared/services/application/application.service';
import { BaseComponent } from '../../shared/components/base-component';
import { EVENT } from '../../shared/constants/dali.constants';

@Component({
  selector: 'app-terms-conditions-modal',
  templateUrl: './terms-conditions-modal.component.html',
  styleUrls: ['./terms-conditions-modal.component.scss']
})
export class TermsConditionsModalComponent extends BaseComponent implements OnInit {
  form: FormGroup = this.fb.group({});
  appCurrentApplication: any;
  CONTENT_BOUNDS: any[] | any;
  viewTerms = false;
  constructor(
    private readonly cps: CopyService,
    private readonly fb: FormBuilder,
    private readonly controlContainer: ControlContainer,
    private readonly _link: LinkupService,
    public readonly _app: ApplicationService
  ) { 
    super(_app, _link, "terms-conditions-modal");
  }

  ngOnInit(): void {
    this.loadStaticValues();
    this.initControls();
  }

  async initControls() {
    const form = this.controlContainer.control as FormGroup;
    if (form) {
      this.form = form;
    }
    this.form.addControl("chktycmodal", this.fb.control('', [Validators.required]));
  }

  async loadStaticValues() {
    await super.loadStaticValues();
    if (localStorage.getItem("appCurrentApplication")) {
      this.appCurrentApplication = localStorage.getItem("appCurrentApplication");
    }
    this.CONTENT_BOUNDS = await this.cps.getCopy("terms-conditions-modal");
  }

  displayEv = async () => this.viewTerms = !this.viewTerms;
  close = async ($event: any) => this.viewTerms = false;

  /**
 * Integración cambios
 */
  download = async () => {
    let link = getValueProperty(this.CONTENT_BOUNDS, 'terms.link','');
    try { 
      const a = document.createElement('a');
      a.target = "_blank";
      a.href = link;      
      a.download = link;
      a.click();
      a.remove();
    } catch (ex) {
      console.log('error al descargar'); 
    }
  }

  changeTerms(){
    if(this.form.get("chktycmodal")?.value){
      let eventSetting = this.getSetting("analytics", "trackEvent.e4", "");
      let pageSetting = this.getSetting("analytics", "pageLoad", "");
      let events = [
        {
            "name": "{EVENT.pv2E4setData.pv2E4transactionName.path}",
            "value": EVENT.pv2E4setData.pv2E4transactionName.value
        },
        {
          "name": "{EVENT.pv2E4setData.pv2E4transactionProductCategory.path}",
          "value": getValueProperty(pageSetting, 'transaction.details.productcategory')
        }
      ]; 
      setValueProperty(eventSetting, "events", events);
      this.onEvent(eventSetting);
    }
  }

}
